import React from 'react';
import { LayoutGrid, Table } from 'lucide-react';

// Conmutador tabla/tarjetas. Segmented control sobrio (clases .vista-toggle en
// index.css). Solo iconos + tooltip para que quepa en cualquier barra de filtros.
const VistaToggle = ({ value, onChange }) => (
  <div className="vista-toggle" role="group" aria-label="Modo de vista">
    <button
      type="button"
      className={value === 'table' ? 'active' : ''}
      aria-pressed={value === 'table'}
      title="Ver como tabla"
      onClick={() => onChange('table')}
    >
      <Table size={16} />
    </button>
    <button
      type="button"
      className={value === 'cards' ? 'active' : ''}
      aria-pressed={value === 'cards'}
      title="Ver como tarjetas"
      onClick={() => onChange('cards')}
    >
      <LayoutGrid size={16} />
    </button>
  </div>
);

export default VistaToggle;
